<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html" i18n>Home</a></li>
                <li i18n>Biography Details</li>
                <li></li>
            </ul>
            <h2 i18n>Biography Details</h2>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-content">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <figure>
                                    <img [src]="imageURL+biography?.image" alt="image">
                                </figure>
                            </div>
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <div class="entry-meta">
                                    <h4> <span i18n>Full Name</span>: {{biography?.full_name}}
                                    </h4>
                                </div>
                                <p>{{biography?.bio}}</p>
                            </div>
                            <div class="col-lg-12">
                                <p class="pt-4"> {{biography?.description}}</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>